import React from 'react';

export const PatentDescription = ({goToContact, description}) => {
  const language = (window.localStorage.i18nextLng === 'ja') ? 'ja' : 'en';
  let includesLink;
  let split;
  let translation;
  if (language === 'ja'){
    includesLink = description.includes('お問い合わせください')
    split = description.split('お問い合わせください')
    translation = 'お問い合わせください'
  }else{
    split = description.split('contact us')
    includesLink = description.includes('contact us')
    translation = 'contact us'
  }

  return (
    <p>
      <span>{split[0]}</span>
      {includesLink && <a href='#contact' onClick={goToContact}>{translation}</a>}
      <span>{split[1]}</span>
    </p>
  )
}